export default __webpack_public_path__ + "images/a6f28ab621c90f1e67a2d0d28bf4960b.png";